"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FB_ENV_FE = exports.TAB_ID = void 0;
var end2end_1 = require("@hudled/end2end");
exports.TAB_ID = Math.floor(Math.random() * (Math.pow(10, 12))).toString();
var FB_ENV_OVERRIDE = ['dev', 'staging', 'prod'].includes(localStorage.FB_ENV_OVERRIDE)
    ? localStorage.FB_ENV_OVERRIDE
    : undefined;
exports.FB_ENV_FE = FB_ENV_OVERRIDE !== null && FB_ENV_OVERRIDE !== void 0 ? FB_ENV_OVERRIDE : end2end_1.FB_ENV;
